export enum SellOption {
    VoucherAndTicket = 'voucher_and_ticket',
    VoucherOnly = 'voucher_only',
    TicketOnly = 'ticket_only',
}
